import { collection, onSnapshot } from 'firebase/firestore'
import { useAdminProducts } from '@hooks/useAdminProducts'
import ImageUploader from '@components/ImageUploader'
import styles from '@styles/CrudProduct.module.css'
import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { db } from '@lib/firebase'

const ProductForm = ({ product, onSubmit, darkMode, isEditing = false }) => {
  const { getNextAvailableId } = useAdminProducts()
  const [formData, setFormData] = useState({
    id: '',
    image: '',
    brand: '',
    category: '',
    reference: '',
    price: 0,
    active: true,
  })

  useEffect(() => {
    product ? setFormData(product) : getNextAvailableId().then(id => setFormData(p => ({ ...p, id })))

    const unsubscribe = onSnapshot(collection(db, 'products'), () => {
        if (!isEditing) {
          getNextAvailableId().then(id => setFormData(p => ({ ...p, id })))
        }
    })
    return () => unsubscribe()
  }, [product, getNextAvailableId, isEditing])

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(p => ({ 
      ...p, 
      [name]: name === 'price' ? parseFloat(value) : value 
    }))
  }

  const handleImageUpload = imageUrl => {
    setFormData(p => ({ ...p, image: imageUrl }))
  }

  const handleSubmit = e => {
    e.preventDefault()
    onSubmit(formData)
    if (!isEditing) {
      setFormData({
        id: '',
        image: '',
        brand: '',
        category: '',
        reference: '',
        price: 0,
        active: true,
      })
      getNextAvailableId().then(id => setFormData(p => ({ ...p, id })))
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      id={styles.formQueries}
      className={`${styles.form} ${darkMode ? styles.darkForm : ''}`}
    >
      <h2 className={styles.subtitle}>
        {isEditing ? 'Editar producto' : 'Agregar nuevo producto'}
      </h2>
      <div className={styles.grid}>
        <ImageUploader
          onImageUpload={handleImageUpload}
          currentImage={formData.image}
        />

        <div>
          <label htmlFor='image'>Directorio de Imagen</label>
          <input
            id='image'
            name='image'
            type='text'
            value={formData.image.url || formData.image}
            onChange={handleChange}
            className={darkMode ? styles.darkInput : ''}
            required
          />
        </div>

        <div>
          <label htmlFor='id'>ID</label>
          <input
            id='id'
            name='id'
            type='text'
            value={formData.id}
            onChange={handleChange}
            className={darkMode ? styles.darkInput : ''}
            required
            disabled={!isEditing}
          />
        </div>

        <div>
          <label htmlFor='brand'>Marca</label>
          <input
            id='brand'
            name='brand'
            type='text'
            value={formData.brand}
            onChange={handleChange}
            className={darkMode ? styles.darkInput : ''}
            required
          />
        </div>

        <div>
          <label htmlFor='category'>Categoría</label>
          <select
            id='category'
            name='category'
            className={
              darkMode ? styles.darkSelectCategory : styles.selectCategory
            }
            value={formData.category}
            onChange={handleChange}
            required
          >
            <option value=''>Seleccionar categoría</option>
            <option value='Niños'>Niños</option>
            <option value='Adultos'>Adultos</option>
            <option value='Sobrepuesto'>Sobrepuesto</option>
            <option value='3piezas'>3 Piezas</option>
            <option value='Lentes'>Lentes</option>
          </select>
        </div>

        <div>
          <label htmlFor='reference'>Referencia</label>
          <input
            id='reference'
            name='reference'
            type='text'
            value={formData.reference}
            onChange={handleChange}
            className={darkMode ? styles.darkInput : ''}
            required
          />
        </div>

        <div>
          <label htmlFor='price'>Precio</label>
          <input
            id='price'
            name='price'
            type='number'
            value={formData.price}
            onChange={handleChange}
            className={darkMode ? styles.darkInput : ''}
            required
          />
        </div>
      </div>
      <button type='submit' className={styles.addButton}>
        {isEditing ? 'Actualizar Producto' : 'Agregar Producto'}
      </button>
    </form>
  )
}

ProductForm.propTypes = {
  product: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  darkMode: PropTypes.bool,
  isEditing: PropTypes.bool,
}

export default ProductForm
